var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect, _rect2, _rect3, _rect4, _path18, _path19, _path20, _path21, _rect5, _rect6, _rect7, _rect8, _path22, _path23, _path24, _path25, _path26, _path27, _rect9, _rect10, _rect11, _rect12, _path28, _path29, _path30, _path31, _rect13, _rect14, _rect15, _rect16, _path32, _path33, _path34, _path35, _rect17, _rect18, _rect19, _rect20, _path36, _path37, _path38, _path39, _rect21, _rect22, _rect23, _rect24, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecursoNuevo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b6dcef;}.cls-2{fill:#434341;}.cls-3{fill:#4ab3e5;}.cls-4{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "741.28 115.8 774.07 115.8 771.7 84.77 743.17 84.69 741.28 115.8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.62,118.16H738.77l2.17-35.84,32.95.09Zm-32.83-4.73h27.72l-2-26.3-24.12-.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.94,72.36,627.1,127.93c-8.88,21.48,4.42,80.11,30.82,85l23.18,4.26c24.58,4.52,55.7-23.75,58.88-44.93l6.34-80.34c3-19.68-12.62-38.4-35.45-42.61C689.77,45.4,669,55.19,661.94,72.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.53,220a32.15,32.15,0,0,1-5.85-.52l-23.19-4.27c-8.82-1.62-16.89-8.75-23.35-20.61-11.25-20.68-15.56-52.26-9.23-67.58l.19-.36,34.73-55.4C667.44,53.09,689,42.87,711.29,47c24.07,4.44,40.47,24.29,37.38,45.21l-6.36,80.42c-1.82,12.17-12.06,26.5-26.08,36.51C706.21,216.24,695.87,220,686.53,220Zm-57.32-91c-5.66,14.05-1.36,44.15,9.09,63.34,4,7.37,10.74,16.51,20.05,18.22l23.18,4.27c9.49,1.74,20.83-1.67,32-9.6,12.8-9.13,22.49-22.5,24.15-33.28L744,91.54c2.77-18.41-12-36-33.54-39.94-20.15-3.7-39.62,5.41-46.31,21.66l-.19.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M850.15,72.42,885,128c8.88,21.47-4.42,80.11-30.83,85L831,217.22c-24.57,4.52-55.69-23.75-58.88-44.93L765.74,92c-3-19.69,12.62-38.41,35.45-42.62C822.29,45.47,843,55.25,850.15,72.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M825.59,220.07c-9.35,0-19.68-3.77-29.7-10.92-14-10-24.27-24.34-26.1-36.51v-.16l-6.39-80.26C760.3,71.3,776.7,51.46,800.76,47c22.25-4.09,43.86,6.14,51.49,24.32l34.92,55.75c6.34,15.33,2,46.91-9.22,67.58-6.46,11.87-14.54,19-23.36,20.62l-23.15,4.27A33.15,33.15,0,0,1,825.59,220.07Zm-51.11-48c1.66,10.78,11.36,24.14,24.15,33.28,11.12,7.93,22.47,11.34,32,9.59l23.15-4.26c9.32-1.71,16-10.86,20.06-18.23,10.45-19.19,14.75-49.29,9.09-63.33L848,73.32C841.24,57.08,821.75,48,801.62,51.66c-21.57,4-36.31,21.53-33.54,39.94l0,.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M834.08,226.64a66.74,66.74,0,1,0-66.56-66.74A66.65,66.65,0,0,0,834.08,226.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.08,229A69.1,69.1,0,1,1,903,159.9,69.09,69.09,0,0,1,834.08,229Zm0-133.47a64.37,64.37,0,1,0,64.19,64.37A64.35,64.35,0,0,0,834.08,95.53Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M834.08,204.13A44.23,44.23,0,1,0,790,159.9,44.17,44.17,0,0,0,834.08,204.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.08,206.49a46.59,46.59,0,1,1,46.47-46.59A46.59,46.59,0,0,1,834.08,206.49Zm0-88.45a41.87,41.87,0,1,0,41.74,41.86A41.85,41.85,0,0,0,834.08,118Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M680.32,226.64a66.74,66.74,0,1,0-66.56-66.74A66.65,66.65,0,0,0,680.32,226.64Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M680.32,229a69.1,69.1,0,1,1,68.92-69.1A69.09,69.09,0,0,1,680.32,229Zm0-133.47a64.37,64.37,0,1,0,64.19,64.37A64.35,64.35,0,0,0,680.32,95.53Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M680.32,204.13a44.23,44.23,0,1,0-44.11-44.23A44.17,44.17,0,0,0,680.32,204.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M680.32,206.49a46.59,46.59,0,1,1,46.47-46.59A46.59,46.59,0,0,1,680.32,206.49Zm0-88.45a41.87,41.87,0,1,0,41.74,41.86A41.85,41.85,0,0,0,680.32,118Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1264.13,62a2.37,2.37,0,0,1-1.91-3.78l18.63-25.4a2.38,2.38,0,0,1,3.84,2.82l-18.64,25.39A2.37,2.37,0,0,1,1264.13,62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1228.37,110.77a2.37,2.37,0,0,1-1.92-3.78l18.64-25.4a2.38,2.38,0,1,1,3.83,2.82l-18.63,25.39A2.4,2.4,0,0,1,1228.37,110.77Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1244.57,65.57a2.37,2.37,0,0,1-1.4-.46l-25.39-18.64a2.38,2.38,0,0,1,2.81-3.83L1246,61.28a2.38,2.38,0,0,1-1.41,4.29Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1293.3,101.33a2.37,2.37,0,0,1-1.4-.46l-25.4-18.64a2.38,2.38,0,0,1,2.82-3.83L1294.71,97a2.38,2.38,0,0,1-1.41,4.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1247.89,
    y: 26.34,
    width: 4.75,
    height: 23.84,
    transform: "translate(8.66 190.04) rotate(-8.72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1258.21,
    y: 93.66,
    width: 4.75,
    height: 23.84,
    transform: "translate(-1.43 192.38) rotate(-8.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1210.62,
    y: 74.53,
    width: 23.84,
    height: 4.75,
    transform: "translate(2.5 186.56) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1277.94,
    y: 64.2,
    width: 23.84,
    height: 4.75,
    transform: "translate(4.79 196.05) rotate(-8.71)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.56,171.63a1.53,1.53,0,0,1-.93-.31,1.56,1.56,0,0,1-.34-2.2l16.77-22.84a1.57,1.57,0,0,1,2.54,1.86L125.83,171A1.59,1.59,0,0,1,124.56,171.63Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.39,215.46a1.64,1.64,0,0,1-.94-.3,1.58,1.58,0,0,1-.33-2.21l16.76-22.84a1.58,1.58,0,1,1,2.54,1.87L93.66,214.82A1.58,1.58,0,0,1,92.39,215.46Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107,174.8a1.55,1.55,0,0,1-.93-.31L83.19,157.73a1.58,1.58,0,1,1,1.87-2.54L107.9,172a1.58,1.58,0,0,1-.94,2.85Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.8,207a1.61,1.61,0,0,1-.93-.3L127,189.9a1.57,1.57,0,1,1,1.86-2.54l22.84,16.76a1.58,1.58,0,0,1-.93,2.85Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.5,
    y: 140.08,
    width: 3.15,
    height: 21.44,
    transform: "translate(-21.58 18.74) rotate(-8.72)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.8,
    y: 200.63,
    width: 3.15,
    height: 21.44,
    transform: "translate(-30.65 20.85) rotate(-8.72)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.42,
    y: 183.99,
    width: 21.44,
    height: 3.15,
    transform: "translate(-27.17 15.39) rotate(-8.74)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 136.98,
    y: 174.69,
    width: 21.44,
    height: 3.15,
    transform: "translate(-25.06 24.48) rotate(-8.74)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M609.31,57.64c-1.07,6.47-2,13-3.24,19.4-4.54,23.36-17.4,41.47-35.55,56.3-11.52,9.42-22.8,19.13-34.3,28.58a6.31,6.31,0,0,0-2.59,5.56q.18,12.44,0,24.89c0,1.26-.54,3-1.46,3.69-6.06,4.28-12.29,8.32-18.85,12.7-2-7.12-3.82-13.89-5.67-20.66-1-3.72-2.55-4.81-5.65-2.77-6.68,4.41-12,2.32-16.78-2.75-3.86-4.05-7.58-8.24-11.19-12.52a6.19,6.19,0,0,1-.69-7.79,21.56,21.56,0,0,0,1.7-3.64c1.17-3,.1-5.1-3.06-6l-20.36-5.6c4.43-6.64,8.54-12.95,12.87-19.11.58-.83,2.27-1.2,3.46-1.21,8.05-.11,16.11-.16,24.16,0,2.48.05,4-.89,5.51-2.7,12-14,24-28,36.23-41.72,14.65-16.48,33.77-24.74,54.92-29,4.62-.93,9.31-1.52,14-2.26h6.6ZM561.38,85.4a13.73,13.73,0,0,0-14,13.49A14,14,0,0,0,561.28,113,13.78,13.78,0,0,0,575,99.16,13.53,13.53,0,0,0,561.38,85.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.5,205.61c.74-3.79,1.34-7.61,2.25-11.36,2.5-10.32,7.05-19.42,16-25.93,2.24,1.66,1.92,3.2.51,5.41-5.84,9.15-7.43,19.36-7.19,30.48,11,.41,21.24-1.36,30.57-7.08,2.64-1.61,2.62-1.65,5.45.29-6.4,9.09-15.6,13.64-26,16.18-3.74.92-7.56,1.52-11.35,2.26H444.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M986.05,221.37a1,1,0,0,1-.82-1.61l7.95-10.83a1,1,0,0,1,1.42-.21,1,1,0,0,1,.21,1.41L986.87,221A1,1,0,0,1,986.05,221.37Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M970.81,242.14a1,1,0,0,1-.82-1.61l7.94-10.82a1,1,0,0,1,1.42-.22,1,1,0,0,1,.22,1.41l-8,10.83A1,1,0,0,1,970.81,242.14Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M977.71,222.87a1,1,0,0,1-.59-.19l-10.83-8a1,1,0,0,1-.22-1.41,1,1,0,0,1,1.42-.22L978.31,221a1,1,0,0,1-.6,1.83Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M998.48,238.12a1,1,0,0,1-.59-.2L987.06,230a1,1,0,0,1,1.2-1.64l10.83,7.95a1,1,0,0,1,.21,1.42A1,1,0,0,1,998.48,238.12Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 979.12,
    y: 206.15,
    width: 2.03,
    height: 10.16,
    transform: "translate(-20.7 151.07) rotate(-8.72)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 983.53,
    y: 234.85,
    width: 2.03,
    height: 10.16,
    transform: "translate(-25 152.07) rotate(-8.72)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 963.24,
    y: 226.7,
    width: 10.16,
    height: 2.03,
    transform: "translate(-23.35 149.7) rotate(-8.74)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 991.94,
    y: 222.29,
    width: 10.16,
    height: 2.03,
    transform: "translate(-22.35 154.01) rotate(-8.74)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1346.05,202.37a1,1,0,0,1-.82-1.61l8-10.83a1,1,0,0,1,1.42-.21,1,1,0,0,1,.21,1.41L1346.87,202A1,1,0,0,1,1346.05,202.37Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1330.81,223.14a1,1,0,0,1-.82-1.61l7.94-10.82a1,1,0,0,1,1.42-.22,1,1,0,0,1,.22,1.41l-8,10.83A1,1,0,0,1,1330.81,223.14Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1337.71,203.87a1,1,0,0,1-.59-.19l-10.83-8a1,1,0,0,1-.22-1.41,1,1,0,0,1,1.42-.22l10.82,7.94a1,1,0,0,1-.6,1.83Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1358.48,219.12a1,1,0,0,1-.59-.2L1347.06,211a1,1,0,1,1,1.2-1.64l10.83,7.95a1,1,0,0,1,.21,1.42A1,1,0,0,1,1358.48,219.12Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1339.12,
    y: 187.15,
    width: 2.03,
    height: 10.16,
    transform: "translate(-13.65 205.45) rotate(-8.72)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1343.53,
    y: 215.85,
    width: 2.03,
    height: 10.16,
    transform: "translate(-17.95 206.45) rotate(-8.72)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1323.24,
    y: 207.7,
    width: 10.16,
    height: 2.03,
    transform: "translate(-16.29 204.16) rotate(-8.74)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1351.94,
    y: 203.29,
    width: 10.16,
    height: 2.03,
    transform: "translate(-15.29 208.47) rotate(-8.74)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.55,66a1.34,1.34,0,0,1-1.34-1.33l-.47-30.9a1.35,1.35,0,0,1,2.7,0l.46,30.9A1.34,1.34,0,0,1,335.58,66Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.45,125.31A1.35,1.35,0,0,1,335.1,124l-.47-30.9A1.35,1.35,0,0,1,336,91.71,1.31,1.31,0,0,1,337.33,93l.47,30.9a1.36,1.36,0,0,1-1.33,1.37Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.45,80.82a1.35,1.35,0,0,1,0-2.7l30.9-.46a1.35,1.35,0,1,1,0,2.69l-30.9.47Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.74,79.92a1.35,1.35,0,0,1,0-2.69l30.9-.47A1.39,1.39,0,0,1,383,78.09a1.35,1.35,0,0,1-1.32,1.37l-30.91.46Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 310.68,
    y: 44.45,
    width: 2.7,
    height: 23.39,
    transform: "translate(54.45 240.98) rotate(-45.86)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 358.64,
    y: 90.98,
    width: 2.7,
    height: 23.39,
    transform: "translate(35.61 289.52) rotate(-45.86)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 101.44,
    width: 23.39,
    height: 2.7,
    transform: "translate(21.36 256.05) rotate(-45.87)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 348.08,
    y: 53.48,
    width: 23.39,
    height: 2.7,
    transform: "translate(69.91 274.88) rotate(-45.87)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1433.86,96.15a1.15,1.15,0,0,1-.7-.23,1.19,1.19,0,0,1-.26-1.67l9.39-12.79a1.2,1.2,0,0,1,1.93,1.41l-9.39,12.79A1.19,1.19,0,0,1,1433.86,96.15Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1415.85,120.69a1.15,1.15,0,0,1-.7-.23,1.19,1.19,0,0,1-.26-1.67l9.39-12.79a1.19,1.19,0,1,1,1.92,1.41l-9.38,12.79A1.21,1.21,0,0,1,1415.85,120.69Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1424,97.93a1.23,1.23,0,0,1-.71-.23l-12.79-9.39a1.2,1.2,0,1,1,1.42-1.93l12.78,9.38a1.2,1.2,0,0,1,.26,1.68A1.19,1.19,0,0,1,1424,97.93Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1448.55,115.94a1.22,1.22,0,0,1-.7-.23l-12.79-9.39a1.2,1.2,0,1,1,1.42-1.93l12.78,9.38a1.2,1.2,0,0,1-.71,2.17Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1425.68,
    y: 78.17,
    width: 2.39,
    height: 12,
    transform: "translate(3.74 217.39) rotate(-8.72)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1430.88,
    y: 112.07,
    width: 2.39,
    height: 12,
    transform: "translate(-1.34 218.53) rotate(-8.72)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1406.92,
    y: 102.44,
    width: 12,
    height: 2.39,
    transform: "translate(0.62 215.45) rotate(-8.72)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1440.82,
    y: 97.24,
    width: 12,
    height: 2.39,
    transform: "translate(1.8 220.53) rotate(-8.72)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M927.29,91.15h6.21l14.35,15v-15h9.27v31.49H950.6l-14.09-15v15h-9.22Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M963,91.15h9.5v18a5.68,5.68,0,0,0,1.37,4,4.66,4.66,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V110a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67A14.93,14.93,0,0,1,967,119.7a12.48,12.48,0,0,1-4-9.66Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M997.76,91.15h24.29v8h-14.8v3.74H1020v7.74h-12.73v4h15.25v8H997.76Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1026,91.15h10.35l6.93,19.21L1050,91.15h10.35l-12.91,31.49H1039Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1066.2,95.06a17.15,17.15,0,0,1,23.44,0,16.12,16.12,0,0,1,4.59,11.84,16.1,16.1,0,0,1-4.59,11.83,17.12,17.12,0,0,1-23.44,0,16.1,16.1,0,0,1-4.59-11.83A16.12,16.12,0,0,1,1066.2,95.06Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.24,6.24,0,0,0,4.9-2.18,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M927.29,145.15h15.25a13,13,0,0,1,8.71,2.83,9.71,9.71,0,0,1-.88,15.35,7,7,0,0,1,2.57,3l3.82,10.26H947l-3.28-8.9a2,2,0,0,0-2-1.27h-5v10.17h-9.49Zm9.49,8v5.4h5.67a2.54,2.54,0,0,0,1.94-.76,3,3,0,0,0,0-3.9,2.6,2.6,0,0,0-1.94-.74Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M960.86,145.15h24.3v8H970.35v3.74h12.74v7.74H970.35v4h15.26v8H960.86Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1011.89,158.42a7.17,7.17,0,0,0,.22-1.75,3,3,0,0,0-1.53-2.5,7.76,7.76,0,0,0-9.22,1.17,8.94,8.94,0,0,0-.05,11.16,6.7,6.7,0,0,0,5.22,2.13,6,6,0,0,0,4.16-1.37,5.32,5.32,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-5,9.86,15.84,15.84,0,0,1-10.8,3.87,15.09,15.09,0,0,1-11.43-4.62,17.81,17.81,0,0,1,.2-23.69q4.62-4.63,12.09-4.63a16.33,16.33,0,0,1,10.39,3.21,10,10,0,0,1,4.09,8.22,6.49,6.49,0,0,1-.49,2.56Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1026.29,145.15h9.49v18a5.73,5.73,0,0,0,1.37,4,4.68,4.68,0,0,0,3.62,1.5,4.55,4.55,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V164a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67a15,15,0,0,1-10.48-3.67,12.47,12.47,0,0,1-4-9.66Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.07,145.15h15.25A13,13,0,0,1,1085,148a9.71,9.71,0,0,1-.88,15.35,7,7,0,0,1,2.57,3l3.82,10.26h-9.72l-3.28-8.9a2,2,0,0,0-2-1.27h-5v10.17h-9.49Zm9.49,8v5.4h5.67a2.54,2.54,0,0,0,1.94-.76,3,3,0,0,0,0-3.9,2.6,2.6,0,0,0-1.94-.74Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1103.05,165.35a2,2,0,0,0-.27,1q0,2.75,5.4,2.75c3.09,0,4.64-.45,4.64-1.35s-2.12-1.82-6.35-2.39c-4.59-.71-7.82-1.88-9.72-3.48a8.15,8.15,0,0,1-2.83-6.55,9.8,9.8,0,0,1,3.58-8q3.57-3,9.74-3a16.25,16.25,0,0,1,9.7,2.7,8.21,8.21,0,0,1,3.75,6.93,5,5,0,0,1-.54,2.34h-9a2.55,2.55,0,0,0,.27-1q0-2.66-4.5-2.65c-2.55,0-3.82.48-3.82,1.44s2.13,1.83,6.39,2.34q6.66.81,9.58,3.3a8.51,8.51,0,0,1,2.93,6.82,9.35,9.35,0,0,1-3.8,7.87q-3.81,2.88-10.29,2.89a18.44,18.44,0,0,1-10.37-2.68c-2.68-1.79-4-4.07-4-6.86a5.48,5.48,0,0,1,.58-2.48Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1130.55,149.06a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.24,6.24,0,0,0,4.9-2.18,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursoNuevo);
export default __webpack_public_path__ + "static/media/Recurso_nuevo.46fb616548dfeffac15b0a29a14e1499.svg";
export { ForwardRef as ReactComponent };